export default __webpack_public_path__ + "static/small-icons-light-905d36c47dd6d9b5473912252113411e.png";